// @flow
export const PACKAGE_DETAILS_REQUEST = 'PACKAGE_DETAILS_REQUEST';
export const PACKAGE_DETAILS_REQUESTED_SUCCESS = 'PACKAGE_DETAILS_REQUESTED_SUCCESS';
export const PACKAGE_DETAILS_REQUESTED_ERROR = 'PACKAGE_DETAILS_REQUESTED_ERROR';
